import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_EXECUTION_PENDIENTE = 'Pendiente';
export const STATE_EXECUTION_EN_CURSO = 'En Curso';
export const STATE_EXECUTION_FINALIZADO = 'Finalizado';

// Definición del enum
export const statesExecution = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un estado para la tarea',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_EXECUTION_PENDIENTE,
        label: 'Pendiente',
        description: 'Pendiente de Realizar',
        icon: IconSelector.PendingIcon,
        color: 'DarkRed'
    },
    {
        value: STATE_EXECUTION_EN_CURSO,
        label: 'En Curso',
        description: 'Haciendose actualmente',
        icon: IconSelector.DoIcon,
        color: 'DarkOrange'
    },
    {
        value: STATE_EXECUTION_FINALIZADO,
        label: 'Finalizado',
        description: 'Terminado',
        icon: IconSelector.DoneIcon,
        color: 'DarkGreen'
    }
];
